import { render, staticRenderFns } from "./AuthenticationView.vue?vue&type=template&id=47a4edae&scoped=true&"
import script from "./AuthenticationView.vue?vue&type=script&lang=js&"
export * from "./AuthenticationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a4edae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47a4edae')) {
      api.createRecord('47a4edae', component.options)
    } else {
      api.reload('47a4edae', component.options)
    }
    module.hot.accept("./AuthenticationView.vue?vue&type=template&id=47a4edae&scoped=true&", function () {
      api.rerender('47a4edae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/email/AuthenticationView.vue"
export default component.exports